import axios from 'axios'
// import { Notify } from 'vant';
// import Axios from "axios";
// import store from "../store";
// import Vue from 'vue'
// import store from '@/store'  // 我此项目没有用到vuex，所以vuex代码的都注释了，需要的自己打开使用

// import {ACCESS_TOKEN} from '@/store/mutation-types'

// 创建 axios 实例
// const requests = axios.create({
//   // baseURL: process.env.VUE_APP_API, // 基础url,如果是多环境配置这样写，也可以像下面一行的写死。
//   // baseURL: '127.0.0.1:8012',
//   timeout: 6000 // 请求超时时间
// })

// request interceptor(请求拦截器)
// Axios.interceptors.request.use(
//   config => {
//     if (localStorage.getItem('Authorization')) {
//       config.headers.Authorization = localStorage.getItem('Authorization');
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   });
//
// // response interceptor（接收拦截器）
// Axios.interceptors.response.use(response => {
//   //对非登录注册操作进行快过期token刷新
//   if (!(response.data.status==10||response.data.status==11)){
//     if (isTokenExpired()<10*60&&isTokenExpired()>0){
//       console.log("token快过期了")
//       let param = new URLSearchParams()
//       param.append("token",localStorage.Authorization)
//       Axios.post('/loginBac/user/tokenRefresh',param).then(res=>{
//         if (res.data.status==10){
//           store.commit('loginStatus',{ Authorization:res.data.data.userToken,AuthorExpireTime:res.data.data.expireTime})
//         }else {
//           ElementUI.Message.error(res.data.message)
//         }
//       })
//     }
//     //过期直接登录
//     if (isTokenExpired()<0){
//       localStorage.removeItem('Authorization');
//       localStorage.removeItem('AuthorExpireTime');
//     }
//   }
//
//   return response
// }, async (error) => {
//   if (error.response.status=='504'){
//     ElementUI.Message.error("未连上后端！")
//   }
//   if (error.response.status=='400'){
//     ElementUI.Message.error("出现问题了请联系管理员！")
//   }
//   return Promise.reject()
// })
// function isTokenExpired() {
//   /*从localStorage中取出token有效时间*/
//   let expiredTime = localStorage.AuthorExpireTime/1000
//   /*获取本地时间*/
//   let nowTime = new Date().getTime() / 1000
//   /*获取校验时间差*/
//   let diffTime =expiredTime-nowTime
//   /*如果 < 10分钟，则说明即将过期*/
//   return diffTime
// }
export default axios




// WEBPACK FOOTER //
// ./src/utils/myaxios.js